import uuidV4 from 'lib/string/uuidV4Utils'
import { defineMessages } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { CHECKOUT_ITEM_TYPE_GIFT_CARD } from 'constants/checkout'
import config from 'constants/config'
import { NO_IMAGE_AVAILABLE_ID } from 'constants/image'
import type { Wedding } from 'weddings/api/weddings'

const messages = defineMessages({
  weddingGiftCardDescription: {
    id: 'Az8CgWRMJp-_YAXZkmBD',
    defaultMessage: 'This gift card will be sent to {coupleName}. They can use it towards their next luxury escape.',
    description: 'Description shown on the gift card review step for a wedding gift card',
  },
})

export function generateGiftCardItem(amount: number): App.Checkout.GiftCardItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_GIFT_CARD,
    amount,
    deliveryMethod: 'email',
    content: {},
  }
}

export interface WeddingGiftCardDonor {
  name: string
  message?: string
}

export function generateWeddingGiftCardItem(
  wedding: Wedding,
  amount: number,
  intl: IntlShape,
  donor?: WeddingGiftCardDonor,
): App.Checkout.GiftCardItem {
  const coupleName = `${wedding.partnerOneFirstName} & ${wedding.partnerTwoFirstName}`

  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_GIFT_CARD,
    amount,
    deliveryMethod: 'email',
    content: {
      recipientName: coupleName,
      recipientEmail: wedding.giftNotificationEmail || undefined,
      fromName: donor?.name,
      message: donor?.message,
    },
    product: {
      image: { id: NO_IMAGE_AVAILABLE_ID, url: '' },
      name: `${coupleName}'s Wedding`,
      items: [],
      type: 'gift card',
      location: wedding.locationLabel ?? '',
      url: `${config.SCHEME}://${config.CUSTOMER_PORTAL_HOST}/weddings/${wedding.slug}`,
      description: intl.formatMessage(messages.weddingGiftCardDescription, { coupleName }),
    },
  }
}

export function generateExperienceGiftCardItem(
  experience: App.ExperienceOffer,
  amount: number,
  ticketCounts: Array<{ ticket: App.ExperienceItemTicket, count: number }>,
): App.Checkout.GiftCardItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_GIFT_CARD,
    amount,
    deliveryMethod: 'email',
    content: {},
    product: {
      image: experience.images[0],
      items: ticketCounts.map((ticketItem) => `${ticketItem.ticket.name}${ticketItem.count > 1 ? ` x ${ticketItem.count}` : ''}`),
      name: experience.name,
      type: 'experience',
      location: experience.location.name,
      url: `${config.SCHEME}://${config.CUSTOMER_PORTAL_HOST}/experience/${experience.slug}/${experience.id}`,
    },
  }
}
